<template>
	<div>
		<p><b>PEPSI 1D spectra in the Archive</b></p>
		<br/>
		<ul>
			<li>Finding PEPSI spectra in the archive
				<ul>
					<li>A search for PEPSI raw files (e.g., file name = match "pepsi" for a given date range), will also list the 1D spectra.</li>
					<li>These files will have the "bwl" extension.</li>
					<li>To list all 1D reduced spectra in the archive, enter "bwl" in the file name field then search.</li>
				</ul>
			</li>
			<li>Quick-look preview feature
				<ul>
					<li>Hovering the mouse over one of the BWL files for a few seconds will bring up a pop-up with a continuum normalized plot for that spectra.</li>
				</ul>
			</li>
			<li>File format
				<ul>
					<li>Each BWL file is in standard FITS format.</li>
					<li>The primary HDU is empty (NAXIS = 0), with all data appearing in an extension (EXTEND = T).</li>
					<li>The table has four columns: Arg, Fun, Var, and Mask.</li>
					<li>The Arg column gives the wavelength and the Fun column gives the continuum normalized value for that wavelength.</li>
					<li>The continuum normalized spectra that appears in the pop-up is produced by plotting Fun versus Arg.</li>
				</ul>
			</li>
		</ul>
	</div>
</template>

<script>
export default {
  methods: {
    openModalByRef(ref) {
      this.$root.$refs.helpSidebar.openModalByRef(ref);
    }
  }
}
</script>
